import type { ITaxonomySchema } from "../types/models/Journal.model";
import type { ITaxonomy } from "../types/ITaxonomy";

export const TaxonomyModel2Interface = (
  taxonomySchema?: ITaxonomySchema[]
): ITaxonomy[] => {
  if (!taxonomySchema) return [];

  return taxonomySchema.map((taxonomydata) => {
    const sid = taxonomydata?.Speciality
      ? taxonomydata.Speciality.SpecialityId
      : 0;
    return {
      domainId: taxonomydata.Domain.DomainId,
      fieldId: taxonomydata.Field.FieldId,
      specialityId: sid
    };
  });
};
